module.exports = __webpack_public_path__ + "static/media/teygja_utanverdlaeri_small.b79787a4.png";